import api from './api';

export const downloadFile = async (fileUrl) => {
  return api.get(fileUrl, {
    responseType: 'blob',
  });
}